import logo from '../logo.svg';
import { useNavigate } from 'react-router-dom';

const Logo = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/matchcodes');
  };

  return (
    <div className="logo-container" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
      <img src={logo} className="App-logo" alt="logo" />
    </div>
  );
};

export default Logo; 